// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.template_attribute_role */
var TemplateAttributeRole;
(function (TemplateAttributeRole) {
    TemplateAttributeRole["PARAMETER"] = "PARAMETER";
    TemplateAttributeRole["RECORDING"] = "RECORDING";
})(TemplateAttributeRole || (TemplateAttributeRole = {}));
;
export default TemplateAttributeRole;
/** Zod schema for template_attribute_role */
export const templateAttributeRole = z.nativeEnum(TemplateAttributeRole);
//# sourceMappingURL=TemplateAttributeRole.js.map